{
  "de": {
    "profile": {
      "subNav": {
        "general": "Mein Profil",
        "account": "Konto bearbeiten",
        "privacy": "Privatsphäre",
        "licenses": "Meine Lizenzen",
        "emailSettings": "E-Mail-Einstellungen",
        "authorizedApplications": "Partner Logins",
        "export": "Datenexport"
      },
      "general": {
        "title": "Profil",
        "sectionName": "Name",
        "sectionLocality": "Beruf & Schule",
        "sectionCommunity": "Community",
        "sectionSettings": "Einstellungen",
        "nameHint": "Wir benötigen diese Angaben für die Teilnahmebescheinigung.",
        "nameHintInternational": "Dein vollständiger Name wird nur verwendet, wenn du an einer unserer Weiterbildungen teilnimmst, damit wir dir eine offizielle Teilnahmebescheinigung ausstellen können.",
        "localityHint": "Verbessere deine persönlichen Empfehlungen, indem du weitere Informationen hinzufügst (optional).",
        "localityHintInternational": "Mit den folgenden Angaben hilfst du uns, dir die bestmögliche Erfahrung zu bieten:",
        "communityHint": "Diese Angaben sind optional und werden in unserer Galerie für Unterrichtsmaterialien verwendet.",
        "firstname": "Vorname",
        "lastname": "Nachname",
        "job": "Beruf",
        "customJob": "Anderer Beruf",
        "schoolType": "Schulform",
        "schoolTypeCustom": "Andere Schulform",
        "country": "Land",
        "region": "Bundesland",
        "regionCanton": "Kanton",
        "regionNoCountry": "Wähle zuerst ein Land.",
        "fromSchool": "Kommt von deiner Schule.",
        "gradeList": "Klassenstufen",
        "subjectList": "Fächer",
        "customSubject": "Anderes Fach",
        "avatar": "Profilbild",
        "avatarHelp": "200x200 Pixel empfohlen",
        "avatarUploadError": "Das Profilbild konnte nicht hochgeladen werden.",
        "avatarUploadProgress": "Profilbild wird hochgeladen",
        "communityName": "Community-Name",
        "communityNameHelp": "Wenn du einen anderen Namen für das Teilen von Materialien verwenden möchtest, kannst du ihn hier eingeben. Andernfalls werden wir deinen Vor- und Nachnamen verwenden.",
        "timezone": "Zeitzone",
        "timeFormat": "Zeitformat",
        "locale": "Sprache der Benutzeroberfläche",
        "contentLanguage": "Inhaltssprache",
        "contentLanguageOptions": {
          "false": "Deutschsprachige Angebote 🇩🇪 🇦🇹 🇨🇭",
          "true": "Englischsprachige Angebote 🌎"
        },
        "timeFormatOptions": {
          "TWELVE_HOURS": "12 Stunden",
          "TWENTY_FOUR_HOURS": "24 Stunden"
        },
        "jobOptions": {
          "JOB_TEACHER": "Lehrkraft",
          "JOB_LEADING_TEACHER": "Fachleitung",
          "JOB_PRINCIPAL": "Schulleitung",
          "JOB_UNIVERSITY_STUDENT": "Student*in",
          "JOB_TEACHER_TRAINEE": "Lehramtsanwärter*in",
          "JOB_PARENT": "Elternteil",
          "JOB_SOCIAL_WORKER": "Sozialpädagog*in",
          "JOB_FACULTY_MEMBER": "Hochschuldozent*in",
          "JOB_ADMINISTRATIVE_STAFF": "Verwaltungsmitarbeiter*in",
          "JOB_OTHER": "Sonstiges"
        },
        "selectPlaceholder": "Bitte auswählen",
        "privacyDeletionNotice": "Datenschutzhinweis: Wenn dein Konto länger als zwei Jahre inaktiv bleibt, informieren wir dich per E-Mail über die geplante automatische Löschung. Wenn du es innerhalb eines Monats nach der Benachrichtigung nicht reaktivierst, wird es automatisch gelöscht.",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "deleteAccount": "Konto löschen",
        "deleteAccountDescription": "Das Löschen deines Kontos ist unwiderruflich. Alle deine Daten werden gelöscht.",
        "deleteAccountConfirmation": "Bist du sicher, dass du dein Konto löschen möchtest?",
        "deleteAccountButton": "Konto unwiderruflich löschen",
        "successMessage": "Profil erfolgreich aktualisiert.",
        "errorMessage": "Das Profil konnte nicht aktualisiert werden."
      },
      "account": {
        "title": "Konto bearbeiten",
        "email": "E-Mail",
        "password": "Neues Passwort",
        "passwordHelp": "Leer lassen, falls du es nicht ändern möchtest.",
        "currentPassword": "Aktuelles Passwort",
        "currentPasswordHelp": "Wir brauchen dein aktuelles Passwort, um Änderungen zu bestätigen.",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "invoiceEmailNotice": "Zum Ändern deiner Rechnungs-E-Mail besuche bitte die <a href=\"{portalUrl}\">Abonnementverwaltung</a>.",
        "unconfirmedEmail": "Wir haben eine Bestätigungs-E-Mail an deine neue Adresse gesendet. Bitte bestätige sie.",
        "oauthConnected": "Verbunden mit",
        "oauthConnect": "Verbinde dein fobizz Konto",
        "connectButton": "Mit {provider} verbinden",
        "disconnect": "Verbindung trennen",
        "fobizzId": "fobizz ID",
        "successMessage": "Konto erfolgreich aktualisiert.",
        "errorMessage": "Das Konto konnte nicht aktualisiert werden."
      },
      "disconnectOauth": {
        "title": "Verbindung mit {provider} trennen",
        "hint": "Bitte wähle ein Passwort damit du dich nach der Trennung anmelden kannst.",
        "password": "Neues Passwort",
        "submit": "Verbindung trennen",
        "cancel": "Abbrechen",
        "successMessage": "Die Verbindung wurde erfolgreich getrennt.",
        "errorMessage": "Die Verbindung konnte nicht getrennt werden."
      },
      "privacy": {
        "title": "Privatsphäre Einstellungen",
        "embedConsent": {
          "paragraph": "Du stimmst zu, dass Videoinhalte in Fortbildungen geladen werden und hierzu die erforderlichen Daten, insbesondere deine IP-Adresse, an den Anbieter übermittelt werden. Mit dieser Einwilligung ist es möglich, die Videos in den Fortbildungen zu schauen. Weitere Informationen findest du in unserer Datenschutzerklärung.",
          "agree": "Zustimmung erteilen",
          "disagree": "Zustimmung widerrufen"
        }
      },
      "licenses": {
        "title": "Meine Lizenzen",
        "sectionSubscriptions": "Abos und Einzellizenzen",
        "subtitleSubscriptions": "Du hast die folgenden Einzellizenzen gebucht:",
        "sectionMemberships": "Mitgliedschaften in Lizenzgruppen",
        "subtitleMembershipsWithGroups": "Die folgenden Lizenzgruppen berechtigen dich zur Nutzung der verschiedenen Angebote:",
        "manageSubscription": "Abonnement verwalten",
        "portalError": "Das Abo-Portal konnte gerade nicht geöffnet werden.",
        "buyNow": "Jetzt kaufen",
        "activatedAt": "Aktiviert am",
        "nextBilling": "Nächste Zahlung",
        "billingPeriod": "Zahlungsperiode",
        "billingPeriodUnits": {
          "year": "Jährlich",
          "month": "Monatlich"
        },
        "paused": "Pausiert",
        "resumed": "Fortgeführt",
        "cancelledAt": "Beendet am",
        "usageUntil": "Nutzbar bis",
        "price": "Preis",
        "statusExpired": "Abgelaufen",
        "statuses": {
          "ACTIVE": "Aktiv",
          "IN_TRIAL": "Trial",
          "NON_RENEWING": "Läuft aus",
          "PAUSED": "Pausiert",
          "CANCELLED": "Gekündigt",
          "FUTURE": "Zukünftig"
        },
        "planTitles": {
          "combined": "Fortbildungs-Flatrate + Tools-Flatrate",
          "courses": "Fortbildungs-Flatrate",
          "tools": "Tools-Flatrate"
        },
        "planDescriptions": {
          "combined": "Unbegrenzter Zugriff auf alle fobizz Fortbildungsangebote, fobizz Tools und KI-Assistenz für den Unterricht.",
          "courses": "Unbegrenzter Zugriff auf alle fobizz Fortbildungsangebote.",
          "tools": "Unbegrenzter Zugriff auf fobizz Tools und KI-Assistenz für den Unterricht."
        },
        "offerHeading": "Dein flexibles fobizz Abo",
        "offerDescription": "Hast du Lust, dich jederzeit flexibel weiterzubilden oder die fobizz Tools und KI unlimitiert zu nutzen? Lerne alle fobizz Angebote kennen.",
        "offerButton": "Angebote vergleichen",
        "offerHint": "Bitte beachte: Aufgrund von Mehrwertsteuerbestimmungen können wir derzeit keine Lizenzen an <strong>Einzelanwender</strong> in Ländern außerhalb der Europäischen Union und der Schweiz anbieten. Wir bieten jedoch Lizenzen für Schulen und Bildungseinrichtungen <strong>in allen Ländern</strong> an."
      },
      "emailSettings": {
        "title": "E-Mail-Einstellungen",
        "subheading": "E-Mail-Benachrichtigungen",
        "labelCourses": "Hinweise auf neue Kurse, Live-Webinare, Rabattaktionen und Schulaktionen (empfohlen)",
        "frequency": "Newsletter-Häufigkeit",
        "frequencyOptions": {
          "WEEKLY": "Wöchentlich",
          "NEVER": "Nie"
        },
        "save": "Speichern",
        "successMessage": "E-Mail-Einstellungen aktualisiert.",
        "errorMessage": "Die E-Mail-Einstellungen konnten nicht aktualisiert werden."
      },
      "authorizedApplications": {
        "title": "Partner Logins",
        "hint": "Diese Partner Anwendungen sind mit deinem fobizz Konto verbunden. Zu den <a href=\"https://app.fobizz.com/en/partners\" class=\"text-decoration-underline\">Partnern</a>.",
        "application": "Anwendung",
        "createdAt": "Verbunden seit",
        "revoke": "Widerrufen",
        "revokeConfirmation": "Bist du sicher?",
        "noApplications": "Keine autorisierten Anwendungen."
      },
      "export": {
        "title": "Datenexport",
        "description": "Hier kannst du alle deine Daten herunterladen. Der Export wird als ZIP-Datei bereitgestellt und enthält alle deine Daten im JSON-Format sowie alle hochgeladenen Dateien.",
        "buttonCreate": "Daten exportieren",
        "buttonDownload": "Datenexport herunterladen",
        "confirmCreate": "Möchtest du einen Datenexport starten?",
        "processing": "Ein Datenexport ist in Bearbeitung. Es kann mehrere Stunden dauern, ihn zu generieren. Du wirst per E-Mail benachrichtigt, sobald er fertig ist.",
        "availableUntil": "Der Export ist 3 Tage verfügbar und wird danach gelöscht."
      }
    }
  }
}
